import styled from "styled-components";

import { Menu } from "@libraries/mui/components";

export const Container = styled(Menu)`
  .MuiPaper-root {
    width: 384px;
    max-width: calc(100vw - 32px);
    border-radius: 12px;
    border: 1px solid #e8edf3;
    box-shadow: 0 12px 32px rgba(0, 30, 70, 0.18);
  }

  .MuiList-root {
    padding: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px 12px;
  border-bottom: 1px solid #eef1f5;
`;

export const HeaderTitle = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #3a4a5c;
`;

export const HeaderAction = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.theme.brand.navyMed};
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.brand.navyHover};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 28px 20px;

  .MuiSvgIcon-root {
    color: #b7c3d3;
    font-size: 30px;
  }
`;

export const EmptyTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.theme.brand.muted};
  text-align: center;
`;

export const EmptySubtitle = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.brand.soft};
  text-align: center;
  line-height: 1.5;
`;

export const Footer = styled.button`
  border: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 18px;
  border-top: 1px solid #eef1f5;
  background: #fafbfd;
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.theme.brand.navyMed};
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.brand.navyHover};
  }
`;
